const SUCCESS_COLORS = new Set(['#28a745', '#20c997', '#198754', '#4caf50', '#5ab175']);
const WARNING_COLORS = new Set(['#ffc107', '#ff9800']);
const DANGER_COLORS = new Set(['#dc3545', '#c82333', '#dc2626']);

export function normalizeHexColor(color) {
  if (!color || typeof color !== 'string') {
    return '';
  }
  return color.trim().toLowerCase();
}

/** Maps interpretation hex colors to semantic tone classes for CSP-safe styling. */
export function getInterpretationTone(color) {
  const normalized = normalizeHexColor(color);
  if (!normalized) {
    return 'neutral';
  }
  if (SUCCESS_COLORS.has(normalized)) {
    return 'success';
  }
  if (WARNING_COLORS.has(normalized)) {
    return 'warning';
  }
  if (DANGER_COLORS.has(normalized)) {
    return 'danger';
  }
  return 'neutral';
}

export function getScoreCircleClass(color) {
  const tone = getInterpretationTone(color);
  if (tone === 'success') {
    return 'score-success';
  }
  if (tone === 'warning') {
    return 'score-warning';
  }
  if (tone === 'danger') {
    return 'score-danger';
  }
  return 'tone-neutral';
}
